import { useGuide } from '~/queries';
import { Guide } from '~/monolith-api';
import { UseQueryResult } from '@tanstack/react-query';
import { useContext, createContext, ReactNode, useState } from 'react';

export type JIBTableContext = {
   isFetching: boolean;

   guide: Guide | null | undefined;
   guideQuery: UseQueryResult<Guide | null, unknown>;

   isReasonsColumnVisible: boolean;
   isKeyPointsColumnVisible: boolean;
   setReasonsColumnVisible: (value: boolean) => any;
   setKeyPointsColumnVisible: (value: boolean) => any;
};

export const JIBTableContext = createContext<JIBTableContext>({} as JIBTableContext);

type JIBTableProviderProps = {
   guideid: number;
   children: ReactNode;
   releaseid: number | null;
};

export function JIBTableProvider({ children, guideid, releaseid }: JIBTableProviderProps) {
   const [isReasonsColumnVisible, setReasonsColumnVisible] = useState(false);
   const [isKeyPointsColumnVisible, setKeyPointsColumnVisible] = useState(false);

   const guideQuery = useGuide(guideid || null, { releaseid: releaseid });
   let { data: guide, isFetching } = guideQuery;

   const jibTableContext: JIBTableContext = {
      guide,
      guideQuery,
      isFetching,
      isReasonsColumnVisible,
      setReasonsColumnVisible,
      isKeyPointsColumnVisible,
      setKeyPointsColumnVisible,
   };

   return <JIBTableContext.Provider value={jibTableContext}>{children}</JIBTableContext.Provider>;
}

export function useJIBTableContext() {
   return useContext(JIBTableContext);
}
